import { useState, useRef } from 'react'
import { ChevronDown, MoveLeft } from 'lucide-react'
import './CourseLanding.css'
import logo from '../../assets/images/storiesLogo.svg'
import heroBg from '../../assets/images/lending/Rectangle 3.png'
import navFounder from '../../assets/images/lending/Group 2765.png'
import navMission from '../../assets/images/lending/Group 2766.png'
import navResults from '../../assets/images/lending/Group 2768.png'
import navProgram from '../../assets/images/lending/Group 2769.png'
import navFormat from '../../assets/images/lending/Group 2771.png'
import navFaq from '../../assets/images/lending/Group 2772.png'
import ownerPhoto from '../../assets/images/lending/owner.png'
import logoGray from '../../assets/images/lending/logo666.svg'
import decor1 from '../../assets/images/lending/Mask group.png'
import decor2 from '../../assets/images/lending/Mask group-1.png'
import decor3 from '../../assets/images/lending/Mask group-2.png'
import decor4 from '../../assets/images/lending/Mask group-3.png'
import decor5 from '../../assets/images/lending/Mask group-4.png'
import decor6 from '../../assets/images/lending/Rectangle 147.png'
import decor7 from '../../assets/images/lending/Rectangle 147-1.png'
import decor8 from '../../assets/images/lending/Rectangle 147-2.png'
import decor9 from '../../assets/images/lending/Rectangle 147-3.png'
import decor10 from '../../assets/images/lending/Rectangle 148.png'
import missionPhoto from '../../assets/images/lending/mission.png'
import module1 from '../../assets/images/lending/Rectangle 75modules.png'
import module4 from '../../assets/images/lending/Rectangle 154modules.png'
import module6 from '../../assets/images/lending/sgrqerh 1modules.png'
import formatLearning1 from '../../assets/images/lending/formatlearning1.png'
import formatLearning2 from '../../assets/images/lending/formatlearning2.png'
import formatLearning3 from '../../assets/images/lending/formatlearning3.jpg'
import socialSecret from '../../assets/images/secret.png'
import socialConditerka from '../../assets/images/conditerka.png'
import socialWeddingTg from '../../assets/images/lending/Mask group-2.png'
import socialWeddingIg from '../../assets/images/lending/Frame 1336585414.png'
import logoLight from '../../assets/images/logoLight.svg'

// TODO: заменить на точное название курса (как на платформе и в образовательной программе)
const COURSE_NAME =
  'Основы кондитерского мастерства: приготовление тортов с различными начинками'

const NAV_ITEMS = [
  { label: 'О создателе', id: 'founder', image: navFounder },
  { label: 'Миссия', id: 'mission', image: navMission },
  { label: 'Результаты', id: 'results', image: navResults },
  { label: 'Программа\nкурса', id: 'program', image: navProgram },
  { label: 'Формат\nобучения', id: 'format', image: navFormat },
  { label: 'FQA', id: 'faq', image: navFaq },
]

const DECORS = [
  { title: 'Торт «Нежные банты»', image: decor1 },
  { title: 'Торт «Нежные цветы»', image: decor9 },
  { title: 'Торт «Бусы»', image: decor2 },
  { title: 'Торт «Нежность»', image: decor3 },
  { title: 'Торт «Корейский дизайн»', image: decor4 },
  { title: 'Торт «Итальянский пирог»', image: decor6 },
  { title: 'Торт «Длинный»', image: decor7 },
  { title: 'Торт «Оригами»', image: decor8 },
  { title: 'Торт «Капуста»', image: decor10 },
  { title: 'Торт «Шторы»', image: decor5 },
]

// Модули 4, 5 и 6 исключены из дубля курса (правка по задаче). Остаются 1–3.
const MODULES = [
  {
    number: 1,
    title: 'Вводный\nмодуль',
    expandedTitle: 'Вводный модуль',
    description: 'Инвентарь, сборка начинок, расчёт пропорций',
    details: [
      {
        heading: 'Урок 0',
        text: '«Вводная часть, знакомство, поздравление, что пришли на курс, краткий рассказ о преимуществах ниши свадебных тортов»',
      },
      {
        heading: 'Урок 1',
        text: '«Необходимый инвентарь для приготовления и оформления свадебных тортов, информация по холодильнику, подложкам, каркасу и опорам»',
      },
      { heading: 'Урок 2', text: '«Подложка»' },
      { heading: 'Урок 3', text: '«Сборка начинок»' },
      { heading: 'Урок 4', text: '«Пропорции торта + перерасчет начинок»' },
    ],
    variant: 'dark' as const,
    image: module4,
  },
  {
    number: 2,
    title: 'Начинки\nтортов',
    expandedTitle: 'Модуль «Начинки»',
    description: '8 уникальных и стабильных начинок от Паулины',
    details: [
      { heading: 'Урок 1', text: 'торт «Фисташка-Малина»' },
      { heading: 'Урок 2', text: 'торт «Тропический»' },
      { heading: 'Урок 3', text: 'торт «Черный лес»' },
      { heading: 'Урок 4', text: 'торт «Сникерс»' },
      { heading: 'Урок 5', text: 'торт «Ваниль-Ягоды»' },
      { heading: 'Урок 6', text: 'торт «Нутелла»' },
      { heading: 'Урок 7', text: 'торт «Медовик»' },
      { heading: 'Урок 8', text: 'торт «Банан-Карамель»' },
    ],
    variant: 'light' as const,
    image: module6,
  },
  {
    number: 3,
    title: 'Покрытия\nтортов',
    expandedTitle: 'Модуль «Покрытия»',
    description: 'Ганаш, мастика, велюр: нанесение без дефектов',
    details: [
      {
        heading: 'Блок 1',
        text: '«Ганаш»',
        bullets: [
          'Виды и преимущества ганаша;',
          'Пошаговая технология ганаша;',
          'Работа с ганашем;',
          'Частые ошибки при работе с ганашем и их исправление',
        ],
      },
      {
        heading: 'Блок 2',
        text: '«Мастика»',
        bullets: [
          'Виды мастики;',
          'Разница в свойствах и применении мастики;\n– Как работать с мастикой;\n– Как избежать трещин, пузырей и нежелательных складок;\n– Как хранить мастику ',
        ],
      },
      {
        heading: 'Блок 3',
        text: '«Велюр»',
        bullets: [
          'Что из себя представляет + лайфхаки, как не запачкать кухню.',
          'Рецепт велюра, окрашивание;',
          'Как и чем наносить велюр',
        ],
      },
    ],
    variant: 'dark' as const,
    image: module1,
  },
]

const FORMAT_CARDS = [
  {
    title: 'Уроки в записи',
    description: 'Смотрите в любое удобное время',
    image: formatLearning1,
  },
  {
    title: 'Постоянный доступ',
    description: 'Курс остаётся у вас навсегда',
    image: formatLearning2,
  },
  {
    title: 'Поддержка куратора',
    description: 'Помощь, проверка и поддержка',
    image: formatLearning3,
  },
]

const FAQ_ITEMS = [
  {
    question: 'Курс подойдёт новичкам или только опытным кондитерам?',
    answer:
      'Курс рассчитан на тех, кто уже имеет базовые кондитерские навыки. Все технические моменты работы с ярусниками (ганаш, мастика, опоры) мы разбираем с нуля и подробно.',
  },
  {
    question: 'А если у меня домашняя кухня и обычный холодильник?',
    answer:
      'Мы специально адаптировали все пропорции под стандартные домашние холодильники. Только последний бонус-урок (двухметровый торт) требует промышленных масштабов — он для вдохновения и понимания границ возможного.',
  },
  {
    question: 'Какое оборудование и инструменты понадобятся?',
    answer:
      'В курсе есть отдельная лекция про инвентарь: от обязательного минимума до того, что облегчает жизнь кондитеру. Всё это можно найти в обычных кондитерских магазинах, ничего уникального не требуется.',
  },
  {
    question: 'Как долго будет доступ к материалам?',
    answer:
      'Доступ остаётся навсегда. Вы можете пересматривать уроки в любое время, а также задавать вопросы куратору.',
  },
  {
    question: 'Входят ли в курс рецепты начинок?',
    answer:
      'Да, 8 фирменных начинок, которые мы используем в курсе. Все с видео и точными пропорциями.',
  },
  {
    question: 'Можно ли оплатить из другой страны?',
    answer: 'Да, принимаем карты РФ и зарубежные карты через платёжный сервис.',
  },
]

// PDF образовательной программы (лежит в корне /public). Используется в подвале и в блоке «О создателе».
// Путь /docs/* на проде занимает бэкенд (Swagger FastAPI) и отдаёт 404, поэтому файл — в корне.
const EDUCATION_PROGRAM_URL = '/education-program.pdf'

// Юридические документы в подвале. Первые 4 — те же ссылки на Яндекс.Диск,
// что и в форме регистрации (см. LEGAL_DOCS в EmailStep). Программа — PDF из /public.
const FOOTER_LEGAL_LINKS = [
  { label: 'Оферта', href: 'https://disk.yandex.ru/i/AOx4E6p6fJR6tw' },
  {
    label: 'Политика обработки персональных данных',
    href: 'https://disk.yandex.ru/i/cJxDXEnl_suXFw',
  },
  {
    label: 'Согласие на обработку персональных данных',
    href: 'https://disk.yandex.ru/i/U3v6FoxTa343Ng',
  },
  {
    label: 'Согласие на информационную рассылку',
    href: 'https://disk.yandex.ru/i/8Aq7PYE-nrFKxQ',
  },
  {
    label: 'Выписка из реестра лицензий',
    href: 'https://disk.yandex.ru/i/1SganwcZ6rBsRQ',
  },
  { label: 'Образовательная программа', href: EDUCATION_PROGRAM_URL },
  // Раздел собирается статикой в public/sveden (см. scripts/sveden): его читает
  // автоматическая проверка Рособрнадзора, которая не выполняет JavaScript.
  // Поэтому ссылка обычная, а не роут react-router.
  { label: 'Сведения об образовательной организации', href: '/sveden/' },
]

const WeddingCourseV2Landing = () => {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null)
  const [openModuleIndex, setOpenModuleIndex] = useState<number | null>(null)
  const sectionRefs = useRef<Record<string, HTMLElement | null>>({})

  const scrollToSection = (id: string) => {
    sectionRefs.current[id]?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index)
  }

  return (
    <div className="cl-page">
      {/* === HERO === */}
      <section className="cl-hero">
        {/* Тёмный хедер-бар */}
        <div className="cl-hero-header">
          <img src={logo} alt="" className="cl-hero-logo" />
        </div>
        {/* Фото-блок с оверлеем */}
        <div
          className="cl-hero-photo"
          style={{ backgroundImage: `url(${heroBg})` }}
        >
          <div className="cl-hero-overlay">
            <div className="cl-hero-badge">Новая программа</div>
            <div className="cl-hero-title-block">
              <h1 className="cl-hero-title">{COURSE_NAME}</h1>
              <p className="cl-hero-author">Автор курса: Филимонова Полина</p>
            </div>
          </div>
        </div>
      </section>

      {/* === NAV === */}
      <section className="cl-nav">
        <div className="cl-nav-scroll">
          {NAV_ITEMS.map(item => (
            <button
              key={item.id}
              className="cl-nav-item"
              onClick={() => scrollToSection(item.id)}
            >
              <img
                src={item.image}
                alt={item.label}
                className="cl-nav-circle"
              />

              <span className="cl-nav-label">{item.label}</span>
            </button>
          ))}
        </div>
      </section>

      {/* === COURSE TITLE === */}
      <section className="cl-wedding-title">
        <h2 className="cl-wedding-heading">{COURSE_NAME}</h2>
        <p className="cl-wedding-desc">
          Полная система от начинок до сборки многоярусных тортов и трендовых
          декоров
        </p>
      </section>

      {/* === FOUNDER === */}
      <section
        className="cl-founder"
        ref={el => {
          sectionRefs.current['founder'] = el
        }}
      >
        <div className="cl-founder-card">
          <img
            src={ownerPhoto}
            alt="Автор курса"
            className="cl-founder-photo"
          />
          <div className="cl-founder-logo">
            <span className="cl-section-label">
              Автор курса: Филимонова Полина
            </span>
          </div>
          <div className="cl-founder-text">
            <p>Привет, это Полина! </p>
            <p>
              Я кондитер с 12‑летним опытом, основатель кондитерской в Дубае, вы
              можете меня знать по популярным роликам из соцсетей.
            </p>
            <p>
              Один из моих лучших проектов, которым я безумно горжусь является
              закрытое сообщество, где делюсь рецептами из нашего цеха,
              технологиями декора и стратегиями кондитерского бизнеса.
            </p>
          </div>
          <a
            href={EDUCATION_PROGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="cl-founder-program-link"
          >
            Образовательная программа
          </a>
        </div>
      </section>

      {/* === DECORS === */}
      <section
        className="cl-decors"
        ref={el => {
          sectionRefs.current['results'] = el
        }}
      >
        <div className="cl-decors-title-block">
          <h3 className="cl-section-title">Декоры на курсе</h3>
        </div>

        <div className="cl-decors-scroll">
          {DECORS.map((decor, idx) => (
            <div key={idx} className="cl-decor-card">
              <img
                src={decor.image}
                alt={decor.title}
                className="cl-decor-image"
              />
              <p className="cl-decor-name">{decor.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* === SOCIAL === */}
      <section className="cl-social">
        <div className="cl-social-top">
          <h3 className="cl-social-title">Социальные сети</h3>
          <img src={logoGray} alt="" className="cl-social-logo" />
        </div>
        <div className="cl-social-icons">
          <a
            href="https://www.instagram.com/pauline_secret_chat?igsh=aHc3YWVhYTRybXU1"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialSecret}
              alt="Secret Chat"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/+HE28136iRUA4MDEy"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialConditerka}
              alt="Кондитерка"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://www.instagram.com/pauline_wedding_course?igsh=MTl0ano3aml5dDEzcQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingIg}
              alt="Wedding Course IG"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/pauline_wedding_course"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingTg}
              alt="Wedding Course TG"
              className="cl-social-icon-img"
            />
          </a>
        </div>
      </section>

      {/* === MISSION === */}
      <section
        className="cl-mission"
        ref={el => {
          sectionRefs.current['mission'] = el
        }}
      >
        <div className="cl-mission-card">
          <img
            src={missionPhoto}
            alt="Автор курса"
            className="cl-founder-photo"
          />
          <div className="cl-founder-logo">
            <span className="cl-section-label">Миссия курса</span>
            {/* <img src={logoGray} alt="" /> */}
          </div>
          <div className="cl-founder-text">
            <p>
              {' '}
              Я знаю, что многим страшно начинать заниматься свадебным из-за
              особой ответственности.{' '}
            </p>
            <p>
              И моя задача - дать вам систему и погрузить вас во все процессы,
              чтобы вы сами почувствовали контроль над свадебными тортами.
            </p>
            <p>
              Вы будете точно знать, какую начинку выбрать, как рассчитать
              пропорции под любой холодильник, как собрать надёжные опоры,
              идеально покрыть торт и украсить так, чтобы декор не отвалился по
              дороге. Всё, что мы наработали за годы работы в курсе, — для
              вашего спокойного и успешного свадебного сезона.
            </p>
          </div>
        </div>
      </section>

      {/* === PROGRAM === */}
      <section
        className="cl-program"
        ref={el => {
          sectionRefs.current['program'] = el
        }}
      >
        <div className="cl-program-header">
          <span className="cl-program-label">Программа</span>
          <h2 className="cl-program-course-name">{COURSE_NAME}</h2>
        </div>
        <div className="cl-program-scroll">
          {MODULES.map((mod, idx) => {
            const isOpen = openModuleIndex === idx
            return (
              <div
                key={mod.number}
                className={`cl-module-card cl-module-card--${mod.variant}${isOpen ? ' cl-module-card--open' : ''}`}
              >
                {isOpen ? (
                  <div className="cl-module-detail-block">
                    <div
                      className="cl-module-back-btn"
                      onClick={() => setOpenModuleIndex(null)}
                    >
                      <MoveLeft size={14} />
                    </div>
                    <h4 className="cl-module-detail-title">
                      {mod.expandedTitle}
                    </h4>
                    <div className="cl-module-detail-text">
                      {mod.details.map((section, i) => (
                        <div key={i} className="cl-module-detail-section">
                          <p>
                            <strong>{section.heading}</strong> {section.text}
                          </p>
                          {'bullets' in section && section.bullets && (
                            <ul className="cl-module-detail-bullets">
                              {section.bullets.map((item, j) => (
                                <li key={j}>{item}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="cl-module-card-block">
                      <div className="cl-module-badge">
                        <span>Модуль {mod.number}</span>
                      </div>
                      <h4 className="cl-module-title">{mod.title}</h4>
                      <p className="cl-module-desc">{mod.description}</p>
                    </div>
                    <img
                      src={mod.image}
                      alt={mod.title}
                      className="cl-module-image"
                    />
                    <div
                      className="cl-module-more"
                      onClick={() => setOpenModuleIndex(idx)}
                    >
                      <span>Подробнее</span>
                    </div>
                  </>
                )}
              </div>
            )
          })}
        </div>
      </section>

      {/* === FORMAT === */}
      <section
        className="cl-format"
        ref={el => {
          sectionRefs.current['format'] = el
        }}
      >
        <h2 className="cl-format-course-name">{COURSE_NAME}</h2>
        <h3 className="cl-section-title">Формат обучения</h3>
        <div className="cl-format-scroll">
          {FORMAT_CARDS.map((card, idx) => (
            <div key={idx} className="cl-format-card">
              <img
                src={card.image}
                alt={card.title}
                className="cl-format-card-image"
              />
              <div className="cl-format-card-body">
                <h4 className="cl-format-card-title">{card.title}</h4>
                <p className="cl-format-card-desc">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* === FAQ === */}
      <section
        className="cl-faq"
        ref={el => {
          sectionRefs.current['faq'] = el
        }}
      >
        <h2 className="cl-faq-label">FQA</h2>
        <h3 className="cl-section-title">Часто задаваемые вопросы</h3>
        <div className="cl-faq-list">
          {FAQ_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className={`cl-faq-item ${openFaqIndex === idx ? 'cl-faq-item--open' : ''}`}
              onClick={() => toggleFaq(idx)}
            >
              <div className="cl-faq-question">
                <span>{item.question}</span>
                <ChevronDown size={16} className="cl-faq-chevron" />
              </div>
              {openFaqIndex === idx && item.answer && (
                <div className="cl-faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* === FOOTER === */}
      <section className="cl-footer cl-social cl-footer-social-icons">
        <div className="cl-social-top">
          <h3 className="cl-social-title cl-footer-social-title">
            Социальные сети
          </h3>
          <img src={logoLight} alt="" className="cl-social-logo" />
        </div>
        <div className="cl-social-icons ">
          <a
            href="https://www.instagram.com/pauline_secret_chat?igsh=aHc3YWVhYTRybXU1"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialSecret}
              alt="Secret Chat"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/+HE28136iRUA4MDEy"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialConditerka}
              alt="Кондитерка"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://www.instagram.com/pauline_wedding_course?igsh=MTl0ano3aml5dDEzcQ=="
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingIg}
              alt="Wedding Course IG"
              className="cl-social-icon-img"
            />
          </a>
          <a
            href="https://telegram.me/pauline_wedding_course"
            target="_blank"
            rel="noopener noreferrer"
            className="cl-social-icon"
          >
            <img
              src={socialWeddingTg}
              alt="Wedding Course TG"
              className="cl-social-icon-img"
            />
          </a>
        </div>

        {/* Юридические документы и реквизиты (пока заглушки) */}
        <div className="cl-footer-legal">
          <nav className="cl-footer-legal-links">
            {FOOTER_LEGAL_LINKS.map(link => (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="cl-footer-legal-link"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <div className="cl-footer-requisites">
            <p>Индивидуальный предприниматель Филимонова Полина Дмитриевна</p>
            <p>ИНН 544593408683</p>
            <p>ОГРНИП 317547600166011</p>
            <p>г. Бердск</p>
            <p>тел. +7 (969) 475-91-06</p>
            <p>e-mail Pauline.School@yandex.ru</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default WeddingCourseV2Landing
